{
  "columnResizer": "Veeru suuruse muutja",
  "loading": "Laadimine...",
  "loadingMore": "Laadi rohkem...",
  "resizeColumn": "Muuda veeru suurust",
  "sortAscending": "Sordi kasvavalt",
  "sortDescending": "Sordi kahanevalt"
}
